import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import R from 'common/res/R';

class InputIconWrapper extends Component {
  render() {
    const { Icon, style, children } = this.props;

    return (
      <View style={[style, styles.container]}>
        <View style={styles.icon}>
          <Icon />
        </View>
        <View style={styles.inputField}>{children}</View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  icon: {
    alignSelf: 'flex-end',
    marginRight: R.spacing.xs,
    marginBottom: R.spacing.m,
    width: 24,
    height: 24,
  },
  inputField: {
    flex: 1,
  },
});

export default InputIconWrapper;
